import { COLOR_CANARY_YELLOW, COLOR_FLAVIA_BLUE, COLOR_FOREST_GREEN, COLOR_MAROON, COLOR_SANDY_BROWN, COLOR_SKY_BLUE, numToHex } from "../../style/predefined-colors";
import i18next from "i18next";
export function getAvatarPresetIndex(avatar) {
    return avatarPresets().findIndex((preset) => {
        var _a, _b, _c, _d;
        return preset.baseColor === numToHex(avatar.baseColor) &&
            preset.headGear.id === ((_a = avatar.avatarHat) === null || _a === void 0 ? void 0 : _a.id) &&
            preset.headGear.color === numToHex((_b = avatar.avatarHat) === null || _b === void 0 ? void 0 : _b.color) &&
            preset.clothing.id === ((_c = avatar.avatarShoulder) === null || _c === void 0 ? void 0 : _c.id) &&
            preset.clothing.color === numToHex((_d = avatar.avatarShoulder) === null || _d === void 0 ? void 0 : _d.color);
    });
}
export const avatarPresets = () => [
    {
        name: i18next.t("settings:avatar-editor-preset-flavia", "Flavia"),
        baseColor: COLOR_FLAVIA_BLUE,
        headGear: {
            id: 6,
            color: COLOR_SKY_BLUE
        },
        clothing: {
            id: 0,
            color: COLOR_SKY_BLUE
        }
    },
    {
        name: i18next.t("settings:avatar-editor-preset-builder", "Builder"),
        baseColor: COLOR_SANDY_BROWN,
        headGear: {
            id: 4,
            color: COLOR_CANARY_YELLOW
        },
        clothing: {
            id: 1,
            color: COLOR_MAROON
        }
    },
    {
        name: i18next.t("settings:avatar-editor-preset-carpenter", "Carpenter"),
        baseColor: COLOR_SANDY_BROWN,
        headGear: {
            id: 4,
            color: COLOR_FOREST_GREEN
        },
        clothing: {
            id: 2,
            color: COLOR_MAROON
        }
    },
    {
        name: i18next.t("settings:avatar-editor-preset-electrician", "Electrician"),
        baseColor: COLOR_FOREST_GREEN,
        headGear: {
            id: 4,
            color: COLOR_FLAVIA_BLUE
        },
        clothing: {
            id: 1,
            color: COLOR_SANDY_BROWN
        }
    },
    {
        name: i18next.t("settings:avatar-editor-preset-supervisor", "Supervisor"),
        baseColor: COLOR_FLAVIA_BLUE,
        headGear: {
            id: 6,
            color: COLOR_SANDY_BROWN
        },
        clothing: {
            id: 3,
            color: COLOR_MAROON
        }
    }
];
